<template>
  <div id="gradingscale" class="gradingscale" >
    <b-button v-if="evaluation && getGradeScale(evaluation).scaleType !== 'COLOR'"
              v-bind:id="evaluation.id" class="goal"
              v-on:click="selectEvaluation(evaluation, getGradeScale(evaluation), true)" v-b-tooltip.hover
              v-bind:title="getGradeScaleText(evaluation)"
              :class="[getGradeScale(evaluation).style]" size="sm" variant="success">
      {{getGradeScaleLabel(evaluation)}}
    </b-button>

    <b-popover triggers="click" v-if="!evaluation.lockedDate" v-bind:target="evaluation.id" ref="popover" title="Overall grade">
      <b-container>
        <b-row v-if="activity != null" v-for="scale in filterCriterias(activity.gradingScale.scale)" style="margin-top:20px">
          <b-col cols="2" align-self="center" style="margin-left:-10px;">
            <b-button class="goal" v-on:click="setGradeScaleToEvaluations(scale)" :class="'grade-' + scale.grade">{{scale.label}}</b-button>
          </b-col>
          <b-col cols="10">
            <small><span v-html="scale.text"></span></small>
          </b-col>
        </b-row>
      </b-container>
    </b-popover>
  </div>
</template>
<script>
import api from '../api'

export default {
  name: 'GradingScale',
  props: ['evaluation', 'evaluations', 'selectedEvaluations', 'activeCourseCode', 'activity', 'market'],
  data () {
    return {
      activeGoalPopover: null,
      selectedEvaluationsMutable: this.selectedEvaluations
    }
  },
  watch: {
    selectedEvaluations: function (val) {
      this.selectedEvaluationsMutable = val
    }
  },
  methods: {
    getGradeScale: function (evaluation) {
      if (evaluation.gradingScaleGrade === null) {
        return {label: '', grade: '', criterionType: '', sortOrder: 0, style: 'grade-'}
      } else {
        if (this.market === 'sweden') {
          evaluation.gradingScaleGrade.style = 'grade-' + evaluation.gradingScaleGrade.label
        } else {
          evaluation.gradingScaleGrade.style = 'grade-' + evaluation.gradingScaleGrade.grade
        }
        return evaluation.gradingScaleGrade
      }
    },

    getGradeScaleLabel: function (evaluation) {
      var gradeScale = this.getGradeScale(evaluation)
      if (gradeScale.grade === '') {
        return ''
      } else if (gradeScale.scaleType === 'TEXT') {
        return gradeScale.label
      } else if (gradeScale.scaleType === 'EMOJI') {
        return gradeScale.label
      }
    },

    getGradeScaleText: function (evaluation) {
      var gradeScale = this.getGradeScale(evaluation)
      return gradeScale.grade === '' ? 'Ej bedömd' : gradeScale.text
    },

    selectEvaluation: function (evaluation, goal, forceSelection) {
      if (!forceSelection) {
        evaluation.selected = !evaluation.selected
      } else {
        evaluation.selected = true
      }
      if (goal) {
        if (this.activeGoalPopover !== evaluation.id + goal.id) {
          this.$root.$emit('bv::hide::popover')
        }
        this.activeGoalPopover = evaluation.id + goal.id
      }

      if (!evaluation.lockedDate) {
        if (this.selectedEvaluationsMutable.includes(evaluation.id)) {
          if (!forceSelection) {
            this.selectedEvaluationsMutable.splice(this.selectedEvaluationsMutable.indexOf(evaluation.id), 1)
          }
        } else {
          this.selectedEvaluationsMutable.push(evaluation.id)
        }
      }
    },

    setGradeScaleToEvaluations: function (grade) {
      for (var i in this.selectedEvaluationsMutable) {
        for (var j in this.evaluations[this.activeCourseCode]) {
          if (this.evaluations[this.activeCourseCode][j].id === this.selectedEvaluationsMutable[i]) {
            this.setGradeToEvaluation(this.evaluations[this.activeCourseCode][j], grade)
            this.$root.$emit('bv::hide::popover')
          }
        }
      }
    },

    setGradeToEvaluation: function (evaluation, grade) {
      if (grade && (grade.label !== '' && grade.grade !== '')) {
        api.addGradingScaleGrade(grade, evaluation).then(response => {
          evaluation.gradingScaleGrade = response
        })
      } else {
        api.removeGradingScaleGrade(evaluation).then(response => {
          evaluation.gradingScaleGrade = null
        })
      }

      if (this.selectedEvaluationsMutable.length === 1) {
        this.selectedEvaluationsMutable.length = 0
        evaluation.selected = false
        this.updateParentEvaluations()
      }
    },

    filterCriterias: function (criterias) {
      var notEvaluatedGrade = {
        label: '',
        grade: '',
        text: 'Ej bedömd',
        criterionType: 'TEXT'
      }

      var filteredCriterias = []
      filteredCriterias.unshift(notEvaluatedGrade)
      for (var i in criterias) {
        if (criterias[i].label != '_') {
          filteredCriterias.push(criterias[i])
        }
      }
      return filteredCriterias
    },

    updateParentEvaluations: function () {
      this.$emit('updateEvaluation', this.selectedEvaluationsMutable)
    }
  }
}
</script>
<style>
  .goal {
    height: 28px;
    width: 30px;
    font-weight: 400;
    border: 1px solid #ccc;
    margin: 2px !important;
    padding: 1px;
  }

  .grade:disabled {
    background-color: #CCC !important;
    opacity: 0.2;
  }

  .grade- {
    color: #FFF;
    background-color: #FFF !important;
    border: 1px solid #ccc;
  }

  .grade-s {
    margin-right: -4px;
  }

  .grade-IV {
    background-color: rgb(244, 98, 66) !important;
  }

  .grade-A {
    background-color: rgb(39, 139, 172) !important;
  }

  .grade-C {
    background-color: rgba(39, 139, 172, 0.6) !important;
  }

  .grade-D {
    background-color: #E8CA07 !important;
  }

  .grade-E {
    background-color: rgba(39, 139, 172, 0.2) !important;
  }

  .grade-F {
    background-color: #DBBF09 !important;
  }

  .grade-G {
    background-color: rgba(39, 139, 172, 0.2) !important;
  }

  .grade-- {
    background-color: #F62217 !important;
  }

  .grade-_ {
    background-color: #FFFF66 !important;
  }

  .grade-0 {
    background-color: #FFF !important;
  }

  .grade-1 {
    background-color: #F0B42B !important;
  }

  .grade-2 {
    background-color: rgba(39, 139, 172, 0.2) !important;
  }

  .grade-3 {
    background-color: rgba(39, 139, 172, 0.4) !important;
  }

  .grade-4 {
    background-color: rgba(39, 139, 172, 0.6) !important;
  }

  .grade-5 {
    background-color: rgba(39, 139, 172, 0.8) !important;
  }

  .grade-6 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-7 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-8 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-9 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-10 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-11 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-12 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-13 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-14 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-15 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-16 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-17 {
    background-color: rgb(39, 139, 172) !important;
  }
  .grade-default {
    background-color: rgb(39, 139, 172) !important;
  }

  .grade-G {
    background-color: rgb(39, 139, 172) !important;
  }

  .grade-NG {
    background-color: rgba(39, 139, 172, 0.6) !important;
  }

  .grade-LG {
    background-color: rgba(39, 139, 172, 0.2) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/GradingScale.vue